import React from "react";
import {observer} from "mobx-react-lite";
import nursingHomeStore from "@source/store/nursingHomeStore";
import {canManageConsentDocuments} from "@source/utils/consentAccess";
import {ConsentDocumentHistory} from "@source/components/consentDocuments/consentDocumentHistory";
import {ConsentRequestState} from "@source/components/consentDocuments";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const ConsentHistoryPage = observer(() => {
  const nursingHomeId = nursingHomeStore.getId();
  const organizationId = nursingHomeStore.activeNursingHome?.organization?._id || "";
  return <ConsentDocumentsLayout>{nursingHomeId ? <ConsentDocumentHistory key={`${nursingHomeId}:${organizationId}:all`} nursingHomeId={nursingHomeId} organizationId={organizationId} canManage={canManageConsentDocuments()}/> : <ConsentRequestState variant="empty" title="Select a nursing home" description="Choose a nursing home to view form history."/>}</ConsentDocumentsLayout>;
});
